export enum ERoles {
	unknown = 'unknown',
	administrator = 'administrator',
	viewer = 'viewer',
}

export enum ECompany {
	unknown = 'unknown',
	zee = 'zee',
}
